module.exports = __webpack_public_path__ + "media/images/applicant/icon-iup-blue-a30b992ea2ce7e049523f5653a874caf.svg";